export type PasscodeStatus = 'Inactive' | 'Active' | 'Locked' | 'Reset';

export const PASSCODE_STATUSES: readonly PasscodeStatus[] = ['Inactive', 'Active', 'Locked', 'Reset'];

export interface PasscodeSubmitData {
    oldPasscode?: string;
    temporaryPasscode?: string;
    newPasscode: string;
}

/**
 * Response from FX verify-passcode/token endpoint. `token` and `expiresIn` are only populated
 * when `isValid` is true; the discriminated union lets TypeScript narrow both after a single check.
 */
export type PasscodeVerifyTokenResult =
    | { isValid: true; token: string; tokenType: string; expiresIn: number }
    | { isValid: false; token: null; tokenType: string; expiresIn: null };

export interface PasscodeState {
    passcodeUpdatedAt: Date | null;
    passcodeAttempts: number;
    passcodeStatus: PasscodeStatus;
}

export type PasscodeModalMode = 'create' | 'change' | 'reset';

export interface ResolvePasscodeModeParams {
    passcodeStatus?: PasscodeStatus | null;
    passcodeUpdatedAt?: string | Date | null;
}

export const requiresPasscodeReset = (passcodeStatus?: PasscodeStatus | null): boolean =>
    passcodeStatus === 'Locked' || passcodeStatus === 'Reset';

export const resolvePasscodeModalMode = ({
    passcodeStatus,
    passcodeUpdatedAt,
}: ResolvePasscodeModeParams): PasscodeModalMode => {
    if (requiresPasscodeReset(passcodeStatus)) {
        return 'reset';
    }

    const hasPasscodeDate = Boolean(passcodeUpdatedAt);

    if (passcodeStatus === 'Inactive' || !hasPasscodeDate) {
        return 'create';
    }

    return 'change';
};
